export const GET_REGION = 'ADDRESS/get_regions';
export const GET_PROVINCE = 'ADDRESS/get_provinces';
export const GET_MUNICIPALITIES = 'ADDRESS/get_municipalities';
export const GET_BARANGAYS = 'ADDRESS/get_barangays';
export const SHOW_BARANGAY = 'ADDRESS/show_barangay';
export const UPDATE_BARANGAY = 'ADDRESS/update_barangay';